export default __webpack_public_path__ + "images/gy-49a30b4ff82716f3aaddf3e991aef4aa.svg";